<div id="header-menu">
  <nav id="header-menu-wide" class="header-row" (mouseover)="setIsActive(true)" (mouseout)="setIsActive(false)">
    <div class="header-menu-wide-level1 fx-row fx-row-h-center fx-row-v-center" data-cy="header-content-parent">
      @for (level1Category of menu; track level1Category; let i = $index) {
        <div class="header-menu-wide-level1-item"
          [class.open]="activeWideLevel1Index === i"
          (focusout)="onLevel1FocusOut($event, i)">
          <button
            class="header-menu-wide-level1-label header-menu-label fx-row fx-row-h-center fx-row-v-center"
            (mousedown)="$event.preventDefault()"
            (keydown.enter)="$event.preventDefault(); openWideLevel1AndFocus(i)"
            (keydown.space)="$event.preventDefault(); openWideLevel1AndFocus(i)"
            (keydown.escape)="closeWideMenu()"
            [attr.aria-expanded]="activeWideLevel1Index === i">
            <span>{{ level1Category.name }}<mat-icon>expand_more</mat-icon></span>
          </button>
          <div class="header-menu-wide-level2" [ngStyle]="{ 'min-height.px': level2MenuHeight, 'width.px': level2MenuWidth }">
            <div class="py-2 level2-content">
              @for (level2Category of level1Category.categories; track level2Category) {
                <div
                  class="header-menu-wide-level2-item"
                  (mouseenter)="mouseEnter(level2Category)"
                  (mouseleave)="mouseLeave()"
                  (focusin)="onLevel2FocusIn(level2Category)"
                  (focusout)="onLevel2FocusOut($event)"
                  data-cy="exx-mouseover-link-animate-level2"
                  >
                  <a
                    class="header-menu-wide-level2-label header-menu-label fx-row fx-row-h-space-between fx-row-v-center"
                    [routerLink]="getLinkUrl(level2Category.href)"
                    [attr.tabindex]="activeWideLevel1Index === i ? 0 : -1"
                    (mousedown)="$event.preventDefault()"
                    >
                    {{ level2Category.name }}
                    @if (level2Category.categories) {
                      <div class="fx-row fx-row-h-space-between fx-row-v-center">
                        <mat-icon class="pl-0">chevron_right</mat-icon>
                      </div>
                    }
                  </a>
                  @if (level2Category.categories) {
                    <div class="py-2 header-menu-wide-level3">
                      @for (level3Category of level2Category.categories; track level3Category) {
                        <div
                          class="header-menu-wide-level3-item"
                          data-cy="exx-header-menu-wide-level3-item"
                          >
                          <a class="header-menu-wide-level3-label header-menu-label" [routerLink]="getLinkUrl(level3Category.href)" (mousedown)="$event.preventDefault()">
                            <span>{{ level3Category.name }}</span>
                          </a>
                        </div>
                      }
                      <div class="divider"></div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </nav>

  <nav id="header-menu-narrow" (window:resize)="narrowMenu?.calculateHeight()" (keydown.escape)="closeNarrowMenuFromKeyboard()">
    <!-- inert while closed: the menu is only moved off-screen, so its items would otherwise stay in the tab order -->
    <div class="header-menu-narrow-level1" #headerMenuNarrowLevel1 [attr.inert]="narrowMenu?.menuOpen ? null : ''">
      <div
        id="header-menu-narrow-top"
        class="narrow-top header-menu-horizontal-padding fx-row fx-row-h-space-between fx-row-v-center col-sm-12"
        >
        @if (narrowMenu?.currentLevel != 1) {
          <span class="fx-row header-menu-back">
            <button class="header-menu-img-button" (click)="returnToFirstLevel(); focusLastNarrowCategory()">
              <img src="https://assets.exxactcorp.com/img/exx/misc/back-nav-mobile.svg" alt="go back" />
            </button>
          </span>
        }
        @if (narrowMenu?.currentLevel != 1) {
          <span class="header-back-text">
            {{ narrowMenu?.currentCategory?.name }}
          </span>
        }
        @if (narrowMenu?.currentLevel == 1) {
          <div id="header-menu-greeting">
            <span>Welcome</span>
          </div>
        }
        <button class="header-menu-img-button" (click)="closeNarrowMenuFromKeyboard()">
          <img src="https://assets.exxactcorp.com/img/exx/misc/close-nav-mobile.svg" alt="close menu" />
        </button>
      </div>

      @for (level1Category of menu; track level1Category) {
        <div>
          <div
            class="header-menu-label header-menu-horizontal-padding header-menu-narrow-navigate-next fx-row fx-row-h-space-between col-sm-12"
            [attr.tabindex]="narrowMenu?.currentLevel > 1 ? -1 : 0"
            role="button"
            (click)="openNarrowCategory($event.currentTarget, level1Category)"
            (keydown.enter)="openNarrowCategory($event.currentTarget, level1Category)"
            (keydown.space)="$event.preventDefault(); openNarrowCategory($event.currentTarget, level1Category)"
            data-cy="header-content-narrow-level1-item"
            >
            {{ level1Category.name }}
            @if (level1Category.categories) {
              <div class="header-menu-level1-icon-container">
                <mat-icon class="header-menu-level1-icon">chevron_right</mat-icon>
              </div>
            }
          </div>
          <!-- Only the open category's links are in the tab order; the rest are slid off-screen -->
          <div
            class="header-menu-narrow-level2 col-sm-12"
            id="level-2-menu"
            #headerMenuNarrowLevel2
            [attr.inert]="narrowMenu?.currentLevel > 1 && narrowMenu?.currentCategory === level1Category ? null : ''"
            >
            @for (level2Category of level1Category.categories; track level2Category) {
              <div data-cy="header-content-narrow-level2-item">
                @if (!level2Category.categories) {
                  <a
                    class="header-menu-label pl-2 pr-1"
                    (click)="closeNarrowMenu()"
                    [routerLink]="getLinkUrl(level2Category.href)"
                    >
                    {{ level2Category.name }}
                  </a>
                }
                <div class="pl-2 pr-1">
                  @if (level2Category.categories) {
                    <div
                      [id]="level2Category.name"
                      class="header-menu-label fx-row fx-row-h-space-between"
                      tabindex="0"
                      role="button"
                      (click)="showCategoryChildren($event.currentTarget, level2Category?.name)"
                      (keydown.enter)="showCategoryChildren($event.currentTarget, level2Category?.name)"
                      (keydown.space)="$event.preventDefault(); showCategoryChildren($event.currentTarget, level2Category?.name)"
                      >
                      {{ level2Category.name }}
                      <div class="header-menu-category-toggle">
                        <div class="header-menu-category-toggle-button">
                          <div class="horizontal"></div>
                          <div class="vertical"></div>
                        </div>
                      </div>
                    </div>
                  }
                  <div class="header-menu-category-children" data-cy="header-content-narrow-category-children">
                    <a class="header-menu-label all" (click)="closeNarrowMenu()" [routerLink]="getLinkUrl(level2Category.href)">
                      All {{ level2Category.name }}
                    </a>
                    @for (level3Category of level2Category.categories; track level3Category) {
                      <div>
                        <a
                          class="header-menu-label"
                          (click)="selectCategory($event.currentTarget)"
                          [routerLink]="getLinkUrl(level3Category.href)"
                          >
                          {{ level3Category.name }}
                        </a>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
            <div class="header-menu-narrow-spacer"></div>
          </div>
        </div>
      }

      <div class="header-menu-narrow-spacer"></div>

      <div id="links-container">
        <button-component
          class="mb-1 ml-40"
          (click)="narrowMenu?.toggle()"
                    [buttonOptions]="{
                        text: 'Contact Sales',
                        type: 'primary',
                        iconPosition: 'right',
                        iconName: 'chevron-right',
                        internalLink: '/Contact-Us'
                    }"
        ></button-component>
        <a class="link col-sm-12 ml-2 pt-3" href="https://exxactcorporation.zendesk.com/hc/en-us?return_to=%2Fhc%2Frequests">
          Get Support <mat-icon class="icon">chevron_right</mat-icon>
        </a>
        <a class="link col-sm-12 ml-2 pt-3" routerLink="/Partners" (click)="narrowMenu?.toggle()">
          Partner with us <mat-icon class="icon">chevron_right</mat-icon>
        </a>
      </div>
    </div>

    <button
      id="header-menu-narrow-toggle"
      #headerMenuNarrowToggle
      aria-label="Menu"
      aria-controls="header-menu-narrow"
      [attr.aria-expanded]="narrowMenu?.menuOpen ? 'true' : 'false'"
      (click)="toggleNarrowMenu()"
      >
      @if (narrowMenu) {
        <div>
          <mat-icon [ngClass]="narrowMenu?.menuOpen ? 'hide' : ' '" svgIcon="menu"></mat-icon>
          <mat-icon [ngClass]="!narrowMenu?.menuOpen ? 'hide' : ' '" svgIcon="x"></mat-icon>
        </div>
      }
    </button>
  </nav>
</div>
